<template>
  <div class="synchronous_alert detailBox">
    <div class="detail color33 size12">
      <div class="head colorF size14">
        <span>选择运输商</span>
        <i class="el-icon-close size16 close" @click="close"></i>
      </div>
      <div class="main">
        <shippers-window :backShow="backShow" @shippers-close="close">
        </shippers-window>
      </div>
    </div>
  </div>
</template>

<script>
import shippersWindow from '../../components/new/shippersWindow.vue'
import { changeSetting } from '../../api/getSetting';
export default {
  components: {
    shippersWindow
  },
  data () {
    return {
      state: 'quick',
      backShow: false
    }
  },
  created () {

  },
  methods: {
    close () {
      this.$emit('close', false)
    },
    seachOrder (list) {
      this.$emit('quickSearch', list)
    }
  }
}
</script>

<style scoped>
@import '../../../static/common-css/detail.css';
  .detail {
    width: 800px;
     /*margin-left: -400px;*/
     /*top: 200px;*/
     height: 460px;
  }
  .head {
    align-items: center;
    height: 54px!important;
    background-color: #1F2A33!important;
    color: #fff!important;
  }
  .el-icon-close {
    color: #fff!important;
  }
  .close{
    margin-top: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/new/chooseShipper.vue